/** @jsx jsx */
import {jsx} from 'theme-ui'
import {useState, ChangeEvent} from 'react'
import {useTranslation} from 'react-i18next'

interface IDonationSinglePriceBlock {
  amount: number | null
  userInput: null | 'custom' | 'fixed'
  onAmountChange: (
    amount: number | null,
    userInput: null | 'custom' | 'fixed',
  ) => void
  priceTag: string
}

const DonationSinglePriceBlock: React.FC<IDonationSinglePriceBlock> = ({
  amount,
  userInput,
  onAmountChange,
  priceTag,
}) => {
  const {t} = useTranslation()
  const [customAmount, setCustomAmount] = useState<string>(
    userInput === 'custom' && amount ? String(amount) : '',
  )
  const handleChangeAmount = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value
    setCustomAmount(value)
    onAmountChange(parseInt(value), 'custom')
  }

  return (
    <div sx={{gridColumnEnd: 'span 2'}}>
      <input
        type="number"
        sx={{
          width: '100%',
          height: '100%',
          border: '1px solid #DEE3E3',
          borderRadius: 4,
          padding: '15px 12px',
          fontSize: 13,
          outline: 0,
          '::placeholder': {
            color: '#717A7B',
          },
          '&:focus': {
            border: '1px solid #055064',
          },
        }}
        placeholder={t('Amount') + ' ' + priceTag}
        value={customAmount}
        onChange={handleChangeAmount}
      />
    </div>
  )
}

export default DonationSinglePriceBlock
